import { cms_rootCateListAll } from '@/apis/header/header.api';
import { CategoryClient } from './categoryClient';
import { logger } from '@/utils/logger';
import { SEARCH_EVENT_NAMES } from '@/utils/logger/instance/searchBusinessLogger';

const getCategoryData = async () => {
  // 处理类目数据
  const categoryList: any[] = [];
  let isActive = null;
  logger.info({
    eventName: SEARCH_EVENT_NAMES.CATEGORY_FETCH_START,
  });
  const cateDataResult = await cms_rootCateListAll({});
  if (cateDataResult?.success && cateDataResult?.data) {
    cateDataResult.data.forEach((firstLevel: any) => {
      if (firstLevel.childrenList.length > 0) {
        const newSecondLevel: any = {
          id: firstLevel.id,
          parentId: firstLevel.parentId,
          cateId: firstLevel.cateId,
          cateName: firstLevel.cateName,
          cateAlias: firstLevel.cateAlias,
          cateImageUri: firstLevel.cateImageUri,
          selectedIconUri: firstLevel.selectedIconUri,
          cateLevel: 1,
          language: firstLevel.language,
          childrenList: [],
          bloodIds: firstLevel.bloodIds,
          backgroundColor: firstLevel.backgroundColor,
        };

        firstLevel.childrenList.forEach((secondLevel: any) => {
          if (secondLevel.childrenList.length > 0) {
            secondLevel.childrenList.forEach((thirdLevel: any) => {
              thirdLevel.secondCateName = secondLevel.cateName;
              thirdLevel.secondCateId = secondLevel.cateId;
              thirdLevel.backgroundColor = secondLevel.backgroundColor;
              newSecondLevel.childrenList.push(thirdLevel);
            });
          } else {
            logger.info({
              eventName: SEARCH_EVENT_NAMES.CATEGORY_THIRD_NO_DATA,
              message: secondLevel,
            });
          }
        });

        if (newSecondLevel.childrenList.length > 0) {
          categoryList.push(newSecondLevel);
        }
      } else {
        logger.info({
          eventName: SEARCH_EVENT_NAMES.CATEGORY_SECOND_NO_DATA,
          message: firstLevel,
        });
      }
    });
    if (categoryList && categoryList.length > 0) {
      isActive = { lv1: categoryList[0].cateId };
    }
  }
  if (cateDataResult.data?.length === 0) {
    logger.info({
      eventName: SEARCH_EVENT_NAMES.CATEGORY_FIRST_NO_DATA,
      statusCode: cateDataResult.code,
    });
  }
  return { categoryList, isActive };
};

const Category = async (props: any) => {
  const categoryData = await getCategoryData();
  return <CategoryClient categoryData={categoryData} {...props} />;
};

export default Category;
